var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5829 7.85264C12.5287 7.85264 11.6706 6.99467 11.6706 5.94058C11.6706 4.88648 12.5287 4.02852 13.5829 4.02852C14.637 4.02852 15.4944 4.88648 15.4944 5.94058C15.4944 6.99467 14.637 7.85264 13.5829 7.85264ZM13.5829 0.419922C10.5159 0.419922 8.0201 2.91551 8.0201 5.98285C8.0201 9.88875 12.589 13.5874 13.5829 13.5874C14.5767 13.5874 19.1456 9.88875 19.1456 5.98285C19.1456 2.91551 16.6498 0.419922 13.5829 0.419922ZM1.17055 1.06898C0.524079 1.06898 0 1.593 0 2.23943C0 2.88584 0.524079 3.40988 1.17055 3.40988H5.04604C5.69252 3.40988 6.2166 2.88584 6.2166 2.23943C6.2166 1.593 5.69252 1.06898 5.04604 1.06898H1.17055ZM0 11.7512C0 11.1048 0.524079 10.5808 1.17055 10.5808H5.04604C5.69252 10.5808 6.2166 11.1048 6.2166 11.7512C6.2166 12.3977 5.69252 12.9217 5.04604 12.9217H1.17055C0.524079 12.9217 0 12.3977 0 11.7512Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/Dark.7e63cd44a2812f9cda9c16e939afb6f0.svg";
export { ForwardRef as ReactComponent };